import { connect } from "react-redux";

// Constants
import { sections } from "src/constants";

// Component
import { CheckboxFilterComponent } from "src/components/filters";

// Selectors
import { evaluationTypeFilterConfigSelector } from "src/selectors/ui_config_selectors/alerts";
import { createSectionSelectors } from "src/ui_processors/global/selector_creators";

// Actions
import { createSectionActions } from "src/ui_processors/global/action_creators";

// State
function mapStateToProps(state) {
  return {
    filterConfig: evaluationTypeFilterConfigSelector(state),
    filterCheckedState: createSectionSelectors(
      sections.alerts
    ).createFilterCheckedStateSelector(
      evaluationTypeFilterConfigSelector(state)
    )(state)
  };
}

// Dispatch Actions
function mapDispatchToProps(dispatch) {
  return {
    selectCheckbox: filterObject => {
      dispatch(
        createSectionActions(sections.alerts).selectCheckbox(filterObject)
      );
    },
    deselectCheckbox: filterObject => {
      dispatch(
        createSectionActions(sections.alerts).deselectCheckbox(filterObject)
      );
    }
  };
}

export const SideBarEvaluationTypeFilterContainerAlerts = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckboxFilterComponent);
